(function () {
    'use strict';
    angular.module('Services').factory('PopLockerOperatingHoursTable', PopLockerOperatingHoursTable);

    PopLockerOperatingHoursTable.$inject = [
        'TableLiteFactory',
    ];

    function PopLockerOperatingHoursTable(
        TableLiteFactory
    ) {
        return function (options) {
            const tableData = {
                tableName: 'popLockerOperatingHoursTable',
                form: options.locationForm,
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add Operating Hours',
                        onClick: function () {
                            AddNewOperatingHours();
                        }
                    }]
                },
                config: {
                    noPagination: true,
                    noConfigureTable: true,
                    noItemsView: true,
                    noFooter: true,
                    tableHeight: '200px',
                    tableMinHeight: '200px'
                },
                headers: [
                    {
                        label: 'OPERATING HOURS',
                        viewName: 'operatingHours'
                    },
                    {
                        label: 'Actions',
                        viewName: 'actions',
                    }
                ],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: (callback) => {
                    callback({content: preloadData()});
                },
                callbackFormat: ['success'],
                postRequestCallback: data => {
                    buildTableData(data);
                }
            });

            function preloadData() {
                if (angular.getObjVal(options, 'operatingHours')) {
                    return options.operatingHours.map((oprHrs) => {
                        return {
                            frmDay: oprHrs.startDay,
                            toDay: oprHrs.endDay,
                            frmTime: parseTime(oprHrs.startTime),
                            toTime: parseTime(oprHrs.endTime)
                        }
                    });
                }

                return [];
            }

            function parseTime(timeStr) {
                const time = timeStr.split(':');
                const amPm = time[1].split(' ');

                return {
                    hours: time[0],
                    minutes: amPm[0],
                    amPm: amPm[1]
                }
            }

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                if (!data) {
                    return null;
                }

                angular.forEach(data.content, function (row) {
                    tableData.data.push(buildValues(row));
                });
            }

            function AddNewOperatingHours() {
                if (tableData.form.$invalid) {
                    tableData.form.$setSubmitted(true);
                    return;
                }
                tableData.data.push(angular.extend(buildValues({}), {isNew: true, editMode: true}));
            }

            function buildValues(row) {
                const data = {};
                data.operatingHours = {
                    url: '/templates/pages/carriers/popLockerOperationCells/operating-hrs-cell.html',
                    value: {},
                }
                data.operatingHours = angular.extend(data.operatingHours, row);
                data.actions = {
                    type: 'button',
                    buttons: [{
                        class: `btn btn-primary btn-circle glyphicon glyphicon-pencil ${row.readOnly ? 'btn-disabled' : ''}`,
                        action: (data) => {
                            if (!data.editMode) {
                                data.editMode = true;
                                changeButtons(data);
                                return;
                            }

                            tableData.form.$setSubmitted();
                            if (tableData.form.$invalid) {
                                return false;
                            }

                            data.editMode = false;
                            changeButtons(data);
                        }
                    }, {
                        class: `btn btn-danger btn-circle glyphicon glyphicon-trash ${row.readOnly ? 'btn-disabled' : ''}`,
                        action: (data) => {
                            tableData.data.splice(tableData.data.indexOf(data), 1);
                        }
                    }]
                };
                return data;
            }

            function changeButtons(row) {
                if (row.editMode) {
                    row.actions.buttons[0].class = 'btn btn-success btn-circle glyphicon glyphicon-ok';
                    row.actions.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-remove';
                    return false;
                }

                row.actions.buttons[0].class = 'btn btn-primary btn-circle glyphicon glyphicon-pencil';
                row.actions.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-trash';
            }

            this.tableData = tableData;
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/tables/pop-lockers/PopLockerOperatingHoursTable.js